<template>
  <div>
    <error404 v-if="isNotFound" />
    <slot v-else />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import HttpErrorModel from 'Models/HttpErrorModel';
import Error404 from 'Root/pages/static/Error404.vue';

export default {
  name: 'PageWrapper',

  components: {
    Error404,
  },

  computed: {
    ...mapState(['httpErrorCode']),

    isNotFound() {
      return this.httpErrorCode === HttpErrorModel.NOT_FOUND;
    },
  },
};
</script>

<style scoped>

</style>
